<div #scrollContainer class="nc-infinite-scroll">
    <ng-content></ng-content>
</div>